var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowHead({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54968 14.8246C6.39968 14.6746 6.32051 14.4996 6.31218 14.2996C6.30385 14.0996 6.37468 13.9246 6.52468 13.7746L11.4747 8.82461C11.558 8.74128 11.6413 8.68294 11.7247 8.64961C11.808 8.61628 11.8997 8.59961 11.9997 8.59961C12.0997 8.59961 12.1913 8.61628 12.2747 8.64961C12.358 8.68294 12.4413 8.74128 12.5247 8.82461L17.4747 13.7496C17.6247 13.8829 17.6997 14.0538 17.6997 14.2621C17.6997 14.4704 17.6247 14.6496 17.4747 14.7996C17.3247 14.9496 17.1455 15.0246 16.9372 15.0246C16.7288 15.0246 16.5497 14.9496 16.3997 14.7996L11.9997 10.4246L7.59968 14.8496C7.46635 14.9996 7.29551 15.0704 7.08718 15.0621C6.87885 15.0538 6.69968 14.9746 6.54968 14.8246Z",
    fill: "#353D47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHead);
export default __webpack_public_path__ + "static/media/arrowHead.26182417e6992a8eb5fc5543ae9c4dda.svg";
export { ForwardRef as ReactComponent };